import Grid from "@material-ui/core/Grid"
import React from "react"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FieldSelect from "../../Table/FieldSelect"
import { useCreate } from "./hooks"

const Create = () => {
    const {
        callback, cancelCallback,
        modalTimeStr, disabled, dialogData, isBusiness,
        text, handleChange,
        projectMoney, handleProjectMoneyChange,
        projectId, handleProjectIdChange,
    } = useCreate("single")
    return (
        <BoardConfirmModal
            title="创建预约"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{modalTimeStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>
            {
                // 创建时，只对商务部展示项目编号及项目金额
                isBusiness ? (
                    <>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目编号"
                                value={projectId}
                                onChange={handleProjectIdChange}
                                error={!!(projectId && projectId.length > 50)}
                                helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                        <Grid container direction="column" justify="center">
                            <TextField
                                label="项目金额"
                                value={projectMoney}
                                onChange={handleProjectMoneyChange}
                                error={!!(projectMoney && projectMoney.length > 50)}
                                helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                            />
                        </Grid>
                    </>
                ) : null
            }
        </BoardConfirmModal>
    )
}

export default Create
